import React from "react";
import { message } from "antd";
import { UnifiedTraceableLogModal } from "@ryo/ui";
import traceabilityService from "../../../services/traceabilityService";
import { TTraceableInstance } from "../../../models/traceabilityModel";

interface Props {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  tokenData: any;
  companyUid: string;
  instance: TTraceableInstance | null;
  logTypes: any[];
}

export const CreateTraceableLogModal: React.FC<Props> = ({
  visible,
  onClose,
  onSuccess,
  tokenData,
  companyUid,
  instance,
  logTypes,
}) => {
  const handleSubmit = async ({ log, update_instance_status, update_instance_metadata }: any) => {
    const res = await traceabilityService.createLog(tokenData, {
      company_uid: companyUid,
      log,
      update_instance_status,
      update_instance_metadata,
    });

    if (res?.error) throw new Error(res?.message || "Error al registrar evento");
    message.success("Evento registrado con éxito en el historial");
  };

  return (
    <UnifiedTraceableLogModal
      visible={visible}
      onClose={onClose}
      onSuccess={onSuccess}
      instance={instance}
      logTypes={logTypes}
      onSubmit={handleSubmit}
    />
  );
};

export default CreateTraceableLogModal;
